import Repository from "../Repository";

const CREATE = "create";
const GET = "get";
const DELETE = "delete";
const UPDATE = "update";

export default {
  create(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },

  get(payload) {
    return Repository.post(transformRoute(GET), payload);
  },

  update(payload) {
    return Repository.post(transformRoute(UPDATE), payload);
  },

  delete(payload) {
    return Repository.post(transformRoute(DELETE), payload);
  },
};

const transformRoute = (route) => {
  return `/portfolio/subcategory/${route}`;
};
